import { dataTypes } from '../../ContentManagerKeys';

export const renderTitle = dataType =>
  dataType === dataTypes.catergories
    ? 'edit_category'
    : dataType === dataTypes.criticalIssue
    ? 'edit_critical_issue'
    : 'edit_accordance';
